// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"colorExports.scss"}]);
// Exports
exports.locals = {
	"primaryColor": "#18d2ff",
	"backgroundColor": "#1c1e2d",
	"listColor": "var(--formant-color-primary-steel01)",
	"moduleColor": "var(--formant-color-primary-module)",
	"moduleFocusedColor": "var(--formant-color-primary-steel03)",
	"fieldColor": "var(--formant-color-primary-steel02)",
	"highlightColor": "var(--formant-color-primary-steel03)",
	"foregroundColor": "var(--formant-color-primary-silver)",
	"infoColor": "#20a0ff",
	"warningColor": "#a961e4",
	"errorColor": "#f89973",
	"criticalColor": "#ea719d",
	"interventionColor": "#2ec495",
	"teleopColor": "#18d2ff",
	"portForwardingColor": "#18d2ff",
	"commandRequestColor": "#f9c36e",
	"commandDeliveryColor": "#9a8261",
	"commandResponseColor": "#f9c36e",
	"customColor": "#64d7d4",
	"statefulColor": "#ff34c5",
	"commentColor": "#64d7d4",
	"annotationColor": "#f9c36e",
	"taskSummaryColor": "#20a0ff",
	"systemColor": "#a961e4",
	"onDemandColor": "#a961e4",
	"onlineColor": "#18d2ff",
	"offlineColor": "#657197",
	"terminalBackground": "rgba(28, 30, 45, 0)",
	"terminalBlack": "#2d3855",
	"terminalBlue": "#20a0ff",
	"terminalBrightBlack": "#657197",
	"terminalBrightBlue": "#20a0ff",
	"terminalBrightCyan": "#18d2ff",
	"terminalBrightGreen": "#2ec495",
	"terminalBrightMagenta": "#a961e4",
	"terminalBrightRed": "#ea719d",
	"terminalBrightWhite": "#f8f9fc",
	"terminalBrightYellow": "#f9c36e",
	"terminalCursor": "#bac4e2",
	"terminalCursorAccent": "#bac4e2",
	"terminalCyan": "#20a0ff",
	"foreground": "#3b4668",
	"terminalGreen": "#2d8376",
	"terminalMagenta": "#564a94",
	"terminalRed": "#7f5072",
	"terminalSelection": "#bac4e2",
	"terminalWhite": "#f8f9fc",
	"terminalYellow": "#bac4e2",
	"groupDefaultColor": "#657197",
	"graphCircleData": "#18d2ff",
	"graphCircleRemainer": "#282f45",
	"skyColor": "#f8f9fc",
	"groundColor": "#282f45",
	"xColor": "#ea719d",
	"yColor": "#2ec495",
	"zColor": "#18d2ff"
};
module.exports = exports;
